import { useState, useRef } from "react"
import { useSelector } from "react-redux"
import { routes } from "router"
import { ShareListingModal } from "pagesV2/pro/Experiences/Home/ShareModal"

// A ticketed listing is shared as its page in the new booking widget, which can book it (a direct
// #/widget/ link opens the old widget's page while NEW_BOOKING_WIDGET is off); any other listing as
// its trip page.
const getListingPath = (trip, guideUuid) =>
  trip.experience_type === "ticketed" && guideUuid
    ? routes.widgetExperience({ uuid: guideUuid, id: trip.uuid })
    : routes.tripPath({ id: trip.uuid })

export const useShareModal = () => {
  const guideUuid = useSelector((store) => store.user?.guide?.uuid)
  const [modalProps, setModalProps] = useState({
    listingTitle: "",
    listingAddress: "",
    listingImage: "",
    listingLink: "",
    shareText: ""
  })
  const [visible, setVisible] = useState(false)
  const shareCallback = useRef(null)

  const showShare = (trip) => {
    if (!trip?.id) return

    const url = `${global.location.origin}/#${getListingPath(trip, guideUuid)}`
    const text = `${trip.title}\n\n${trip.address}\n\n`
    const image = trip?.photos?.find?.((img) => img?.position === 0)

    setModalProps({
      listingTitle: trip.title || "",
      listingAddress: trip.address || "",
      listingImage: image?.preview_url || "",
      listingLink: url,
      shareText: text
    })
    setVisible(true)
  }

  const handleClose = () => {
    setVisible(false)
    shareCallback.current = null
  }

  return {
    showShare,
    modal: visible ? (
      <ShareListingModal
        {...modalProps}
        visible={visible}
        onClose={handleClose}
      />
    ) : null
  }
}